import React from "react";
import { StyledHeading } from "../../shared/login_and_sign_up/styled";
import { StyledParagraphMedium } from "./set_new_password_content";
import { Button } from "../../components/base_ui/inputs/button";

export default function NewPasswordSetContent({
  baseUrl,
  title,
  description,
  logInButtonText = "Sign In",
}: {
  baseUrl: string;
  title: string;
  description: string;
  logInButtonText?: string;
}) {
  // Disallow back button to go back to the form, route to sign in page instead.
  window.onpopstate = () => {
    window.location.replace(baseUrl);
  };

  return (
    <>
      <StyledHeading>{title}</StyledHeading>
      <StyledParagraphMedium>{description}</StyledParagraphMedium>
      <Button
        onClick={() => {
          window.location.replace(baseUrl);
        }}
        data-test="log-in-to-dashboard-button"
      >
        {logInButtonText}
      </Button>
    </>
  );
}
